module.exports = __webpack_public_path__ + "static/media/caret-down-light.fd135f44.svg";